<mat-toolbar #header id="header" class="labs-header mat-elevation-z5" *ngIf='isLogged()' [ngStyle]="getHeaderColor()">
    <mat-toolbar-row>

	<button mat-icon-button (click)="toggleSideNav()">
            <mat-icon>menu</mat-icon>
	</button>


        <span class="header-title" [routerLink] = "['/']" style="cursor:pointer" *ngIf="screenState.desktop" >
        
            <img class="logo" src="assets/static/logo_ausl_header.png" style="float:left;" *ngIf="!dark_mode" /> 
        <img class="logo" src="assets/static/logo_ausl_header_dark.png" style="float:left;" *ngIf="dark_mode" /> 

        <div style="padding-left: 10px;">  {{ header_title }}  </div>
        <div style="font-size: 13px; padding-left: 10px; padding-top: 10px;"> ver. {{ getVersion() }} </div></span>

        <!-- <span class="header-title" [routerLink] = "['/']" style="cursor:pointer" *ngIf="screenState.desktop" ><img class="logo" src="assets/static/logo_ausl_header_dark.png" style="float:left;" /> {{ header_title }} <div style="font-size: 13px; padding-left: 10px; padding-top: 10px;"> ver. {{ getVersion() }} </div></span> -->

        <!-- <span class="header-title" [routerLink] = "['/']" style="cursor:pointer" *ngIf="screenState.mobile || screenState.tablet" ><img class="logo" src="assets/static/logo_customer_mobile.png" style="float:left;" /> </span> -->

      <div fxFlex fxLayout fxLayoutAlign="flex-end"  [style.color]="getTextColor()">
      
            <button mat-button (click)="changeTheme()">
              <mat-icon *ngIf="dark_mode" class="icon_20" matTooltip="{{ 'generic.switch_to_light_mode' | translate }}">brightness_4</mat-icon>
              <mat-icon *ngIf="!dark_mode" class="icon_20" matTooltip="{{ 'generic.switch_to_dark_mode' | translate }}">brightness_7</mat-icon>
            </button>
            |

            <span *ngIf="current_user.first_name !== null">
                {{ current_user.first_name }} {{ current_user.last_name }}
            </span>
            <span *ngIf="current_user.first_name === null">
                {{ current_user.username }}
            </span>

            <button mat-icon-button (click)="logout()">
                <mat-icon matTooltip="{{ 'generic.logout' | translate }}">exit_to_app</mat-icon>
            </button>

      </div>
      
  </mat-toolbar-row>
</mat-toolbar>
